import type { SyncProgressSession } from "../components/sync/sync-progress-toast";
import {
  getUserPreferenceJSON,
  setUserPreference,
  setUserPreferenceJSON,
} from "@/lib/preferences";

const storageKey = (jobId: string) => `ats_sync_progress_session:${jobId}`;

export function loadSyncProgressSession(
  jobId: string,
): SyncProgressSession | null {
  const raw = getUserPreferenceJSON<SyncProgressSession>(storageKey(jobId));
  if (!raw?.syncJobId || !raw?.jobId || raw.jobId !== jobId) return null;
  return {
    ...raw,
    startedAt: typeof raw.startedAt === "number" ? raw.startedAt : Date.now(),
  };
}

export function saveSyncProgressSession(session: SyncProgressSession): void {
  setUserPreferenceJSON(storageKey(session.jobId), session);
}

export function clearSyncProgressSession(jobId: string): void {
  setUserPreference(storageKey(jobId), undefined);
}
